import { TopNavigation, TopNavigationContextType } from '@numa-group/ui.top-navigation';

import { useBrand } from '@src/contexts/brand-context';

type NavigationWhileLabelProps = {
  languageSwitcher: JSX.Element;
  isMyTripDetailsPage: boolean;
  content: TopNavigationContextType['content'];
};

export const NavigationWhiteLabel = ({ languageSwitcher, isMyTripDetailsPage, content }: NavigationWhileLabelProps) => {
  const { brand } = useBrand();

  return (
    <TopNavigation
      position="sticky"
      content={content}
      style={{
        '--top-navigation-background-color': brand.primaryColor?.hex,
        '--top-navigation-color': brand.textColor?.hex,
      }}
    >
      {isMyTripDetailsPage ? (
        <>
          <TopNavigation.Logo {...brand.logo} href={brand.websiteUrl} desktopOnly />
          <TopNavigation.MobileBackButton href="/trips" />
        </>
      ) : (
        <TopNavigation.Logo {...brand.logo} href={brand.websiteUrl} />
      )}

      <TopNavigation.Settings>{languageSwitcher}</TopNavigation.Settings>
    </TopNavigation>
  );
};
